import { parseSlateJSONToHTML } from 'components/TextEditor/utils'
import { useBorderListContext } from 'contexts/BorderListContext'
import { useNavigate, useParams } from 'react-router-dom'
import { AlertContext } from 'contexts/AlertContext'
import { useContext, useState } from 'react'
import { POST } from 'api/request'
import * as urls from 'api/urls'
import { Form } from '..'

const useFormSending = (form: Form) => {
  const params = useParams()
  const [isSending, setSending] = useState(false)

  const { reload } = useBorderListContext()
  const { showAlert } = useContext(AlertContext)
  const navigate = useNavigate()

  const submit = async () => {
    setSending(true)
    const formData = new FormData()

    formData.append('is_obituary', '1')
    if (form.selectedImage) {
      formData.append('img', form.selectedImage)
    }

    formData.append('name', form.name)
    formData.append('birth', form.birth)
    formData.append('death', form.death)

    formData.append('obituary[text]', parseSlateJSONToHTML(form.content))

    Object.entries(form.steps).forEach(([stepKey, values]) => {
      Object.entries(values).forEach(([key, value]) => {
        formData.append(`obituary[steps][${stepKey}][${key}]`, `${value}`)
      })
    })

    try {
      if (params['*']) {
        const response = await POST(urls.updatedBoard(params['*']), {
          form: formData
        })
        if (response.ok) {
          const profileID = response.data?.data.id
          reload()
          navigate(profileID ? `/profile/${profileID}` : '/')
          showAlert('Zaktualizowano profil!', 'success')
        } else {
          setSending(false)
          showAlert('Błąd w trakcie aktualizowania!', 'error')
        }

      } else {
        const response = await POST(urls.boards, {
          form: formData
        })
        if (response.ok) {
          const profileID = response.data?.data.id
          reload()
          navigate(profileID ? `/profile/${profileID}` : '/')
          showAlert('Dodano nekrolog!', 'success')
        } else {
          showAlert('Błąd w trakcie dodawania!', 'error')
          setSending(false)
        }
      }

    } catch (err) {
      console.error(err)
    }
    setSending(false)
  }

  return {
    isSending,
    submit
  }
}

export default useFormSending